module.exports = __webpack_public_path__ + "images/9078f01921caf37fbf4f958f782dcce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/npo_logo_small.png
// module id = 1303
// module chunks = 0